import { TextField } from '@mui/material';
import { useField } from 'formik';

export const BrithdayWrapper = ({ name, ...props }: any) => {
  const [field] = useField(name);
  const otherProps = { ...field, ...props };

  return (
    <TextField
      {...otherProps}
      id={props.id}
      type="date"
      fullWidth
      inputProps={{
        max: '2003-12-31',
        min: '1931-12-31',
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};
